import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/laboratorio.jpg'
import Laboratorioall from '../components/laboratorioall'
import { LuTestTubeDiagonal } from 'react-icons/lu'
import emalogo from '../assets/images/ema.jpg'
import { Helmet } from 'react-helmet-async'
import useCsrfToken from '../hooks/useCsrfToken'
import { useState, useEffect } from 'react';
import { allbranchesData } from '../data/data';

export default function Laboratorio() {
    const { csrfToken } = useCsrfToken();
    const basedomain = process.env.REACT_APP_BASE_URL;
    const [catalogfile, setCatalogfile] = useState([]);
    const [reachfile, setReachfile] = useState([]);

    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const transformData = (data) => {
            return [{
                title: data.title,
                catalog_file: data.catalog_file ? `${API_URL}/storage/${data.catalog_file}` : null,
            }];
        };
        const transformData2 = (data) => {
            return [{
                title: data.title,
                reach_file: data.reach_file ? `${API_URL}/storage/${data.reach_file}` : null,
            }];
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/get-catalog-file`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setCatalogfile(transformData(data))
                })
                .catch(error => console.error('Error fetching file:', error));
            fetch(`${API_URL}/api/get-reach-file`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setReachfile(transformData2(data))
                })
                .catch(error => console.error('Error fetching file:', error));
        }
    }, [csrfToken]);
    return (
        <>
            <Helmet>
                <title>Laboratorio | Hospital Aranda de La Parra</title>
                <meta name="description" content="Ordena o consulta tus resultados de laboratorio en Hospital Aranda de La Parra" />
                <meta property="og:title" content="Laboratorio | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Ordena o consulta tus resultados de laboratorio en Hospital Aranda de La Parra" />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/laboratorio`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Laboratorio | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Ordena o consulta tus resultados de laboratorio en Hospital Aranda de La Parra" />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Laboratorio | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Ordena o consulta tus resultados de laboratorio en Hospital Aranda de La Parra" />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Laboratorio</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Laboratorio</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-sm-6 col-12 text-center">
                            <img src={emalogo} alt="" className="mx-auto w-50" />
                            <p>
                                <LuTestTubeDiagonal className="icon text-primary" style={{ fontSize: '1em' }} /> Consulta tus resultados de laboratorio
                            </p>
                            <div className="d-flex flex-wrap justify-content-center gap-2">

                                {reachfile.length > 0 && reachfile[0].reach_file != null &&
                                    (
                                        <Link
                                            to={reachfile[0].reach_file}
                                            target="_blank"
                                            className="btn btn-primary btn-sm text-light hv:bg-secondary"
                                        >
                                            Alcance de la acreditación <i className="mdi mdi-chevron-right align-middle"></i>
                                        </Link>
                                    )
                                }

                                <Link
                                    to="#indicaciones"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const element = document.getElementById('indicaciones');
                                        if (element) {
                                            const yOffset = -150;
                                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                            window.scrollTo({ top: y, behavior: 'smooth' });
                                        }
                                    }}
                                    className="btn btn-primary btn-sm text-light hv:bg-secondary"
                                >
                                    Indicaciones generales <i className="mdi mdi-chevron-right align-middle"></i>
                                </Link>
                                <Link
                                    to="https://www.hemonet.com/arandadelaparra/paciente"
                                    target="_blank"
                                    className="btn btn-success btn-sm text-light hv:bg-secondary"
                                >
                                    Consultar resultados <i className="mdi mdi-chevron-right align-middle"></i>
                                </Link>
                                {catalogfile.length > 0 && catalogfile[0].catalog_file != null &&
                                    (
                                        <Link
                                            to={catalogfile[0].catalog_file}
                                            target="_blank"
                                            className="btn btn-secondary btn-sm text-light hv:bg-secondary"
                                        >
                                            Catálogo completo de estudios <i className="mdi mdi-chevron-right align-middle"></i>
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <Laboratorioall />
                    <div className="row justify-content-center mb-1 mt-5" id='alcance'>
                        <h4>
                            Acreditación EMA
                        </h4>
                        <p className='text-muted small'>
                            Entidad Mexicana de Acreditación A.C. es la primera entidad de gestión privada en nuestro país, que tiene como objetivo acreditar a los Organismos de la Evaluación de la Conformidad que son los laboratorios de ensayo, laboratorios de calibración, laboratorios clínicos, unidades de verificación (organismos de inspección) y organismos de certificación, Proveedores de Ensayos de Aptitud y a los Organismos Verificadores/Validadores de Emisión de Gases Efecto Invernadero (OVV GEI)
                        </p>
                    </div>
                </div>

            </section>

            <section className="section pt-2" id='indicaciones'>
                <div className="container">
                    <div className="row justify-content-center mb-2 mt-1">
                        <h4>
                            Indicaciones generales para el paciente
                        </h4>
                    </div>
                    <div className="row justify-content-center mb-5">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: '25%' }}>Tipo de examen</th>
                                        <th>Indicaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className='small'>
                                        <td><strong>Examen en sangre</strong></td>
                                        <td>
                                            <ol className="mb-0 small">
                                                <li>Ayuno de 8 a 12 horas y cena libre de grasas (puede tomar agua natural). Algunas pruebas solo requieren 4 horas de ayuno.</li>
                                                <li>Evitar ejercicio intenso y bebidas alcohólicas 24 horas antes.</li>
                                                <li>No fumar por lo menos 12 horas antes.</li>
                                                <li>Evite medicamentos antes de la extracción, si es posible.</li>
                                                <li>Consultar con su médico sobre la hora adecuada para pruebas de medicamentos.</li>
                                                <li>Después de estudios con contraste intravenoso, espere al menos 3 días antes de realizarse exámenes de laboratorio.</li>
                                            </ol>
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Examen de orina ocasional</strong></td>
                                        <td className='small'>
                                            Recolectar la primera orina de la mañana (chorro medio) en recipiente estéril. Llevarla al laboratorio antes de una hora.
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Examen de cultivo de orina</strong></td>
                                        <td className='small'>
                                            Realizar aseo con agua y jabón. Recolectar la primera orina de la mañana (chorro medio) en recipiente estéril. Llevarla al laboratorio antes de una hora.
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Examen en orina de 24 horas</strong></td>
                                        <td>
                                            <ol className="mb-0 small">
                                                <li>El laboratorio proporciona el recipiente (con costo reembolsable al realizar el estudio).</li>
                                                <li>Al despertar, deseche la primera orina. Anote hora y fecha de inicio.</li>
                                                <li>Recolectar todas las micciones del día y noche durante 24 horas.</li>
                                                <li>Anotar la hora de la última recolección.</li>
                                                <li>Refrigerar el recipiente durante todo el proceso.</li>
                                                <li>Llevar al laboratorio máximo 30 minutos después de la última recolección.</li>
                                                <li>Conocer su peso y talla es indispensable.</li>
                                            </ol>
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Examen en heces</strong></td>
                                        <td className='small'>
                                            Recolectar una muestra del tamaño de una nuez en recipiente del laboratorio. Evitar contaminación con orina o agua. Llevar la muestra lo antes posible.
                                            <br />
                                            Para estudio de amiba en fresco y moco fecal, llevar la muestra máximo 30 minutos después de emitida.
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Cultivo de exudado faríngeo</strong></td>
                                        <td className='small'>
                                            Presentarse en ayunas y sin aseo bucal.
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Exudado uretral o vaginal</strong></td>
                                        <td className='small'>
                                            Presentarse con previo aseo y sin relaciones sexuales durante los 3 días anteriores.
                                        </td>
                                    </tr>
                                    <tr className='small'>
                                        <td><strong>Estudios de referencia</strong></td>
                                        <td className='small'>
                                            Solicitar al laboratorio las indicaciones específicas de toma de muestra.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <h5 className='fw-bold mt-3'>Disponible en:<br />
                                {allbranchesData && allbranchesData.map((item, index) => (
                                    <span key={index} to="#" className="badge badge-link me-1 bg-lightgray">
                                        {item.title}
                                    </span>
                                ))}
                            </h5>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
